<template>
  <div class="aq">
    <div class="hander">
      <van-icon name="arrow-left" @click="goBack" class='nav_goback' />
    </div>
    <router-view />
  </div>
</template>

<style lang="less" scoped>
  .hander{
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background-color: rgba(255,255,255,.6);
    margin-bottom: 10px;
  }
</style>

<script>
export default {

}
</script>
